<template>
  <div class="t_page">
    <!--淘开抢头部-->
    <grapBuyingNav v-on:lisetenToChildEvent = "lisetenFromChildEvent"></grapBuyingNav>
    <!--已开枪-->
    <div class="buy_wrapper" v-if="!showGrapModal">
      <div class="begin_banner z_banner">
        <div class="coupon_goods_list_ul">
          <!--router-link :to="{ name: 'item', params: { id: dataList.id }}"-->
          <a :href="dataList.click_url" v-for="(dataList,index) in dataLists" :key="dataList.id" :class="index==0?'coupon_goods_list_li1':'coupon_goods_list_li'">
            <div v-if="index==0"  class="coupon_goods_list_li1_inner">
              <div class="li_left">
                <strong class="czg">超值购</strong>
                <img :src="dataList.pic_url" class="goods_pic mt40"/>
                <p v-if="index==1" class="left_coupon">还剩{{dataList.couponReserve
    }} 张券</p>
              </div>
              <div class="li_right">
                <p class="goods_title"><img src="../../images/tmallSelected.png"  v-if="dataList.mallType=='天猫'" class='n_goods_shop_img'/>
                <img src="../../images/taobao.png"  v-if="dataList.mallType!='天猫'" class='n_goods_shop_img' />
                <img src="../../images/haitao.png"  v-if="dataList.isHaiTao==1" class='n_goods_shop_img' />
                <img src="../../images/juhuasuan.png"  v-if="dataList.isJuHuaSuan==1" class='n_goods_shop_img' />
                <img src="../../images/taoqianggou.png"  v-if="dataList.isTaoQiangGou==1" class='n_goods_shop_img' />
                <img src="../../images/video.png"  v-if="dataList.isVideo==1" class='n_goods_shop_img'/>{{dataList.title}}</p>
                <div class="des_wrapper">
                  <div class="des_content">
                    <p class="mark">不可错过 限今日</p>
                    <div class="goods_coupon">
                      <!--span class="goods_coupon_l">领券直降</span><img src="../../images/jrqg_coupon_bg.png" class="goods_coupon_c" /><span class="goods_coupon_r">￥{{dataList.money
          }}</span-->
                    </div>
                    <div class="goods_money">
                      <span class="goods_money_l"><span class="s1">￥{{dataList.zk_final_price}}</span><span class="s2">￥{{dataList.reserve_price}}</span></span>
                    </div>
                    <div class="be_left">
                      <div class="be_left_innner">
                        即将抢完
                      </div>
                    </div>
                  </div>
                  <div class="time_wrapper">
                      <p class="time">
                        <span class="bubble"></span>
                        <span class="time_content">
                          <span class="time1"><span class="time1_big">3</span>s</span>
                          <span class="time2">后换新</span>
                        </span>
                      </p>
                      <div class="btn">
                        去秒杀 >
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else  class="coupon_goods_list_li1_inner center">
              <div class="li_left">
                <img :src="dataList.pic_url" class="goods_pic"/>
                <p v-if="index==1" class="left_coupon">还剩{{dataList.couponReserve
    }} 张券</p>
              </div>
              <div class="li_right">
                <p class="goods_title"><img src="../../images/tmallSelected.png"  v-if="dataList.mallType=='天猫'" class='n_goods_shop_img'/>
                <img src="../../images/taobao.png"  v-if="dataList.mallType!='天猫'" class='n_goods_shop_img' />
                <img src="../../images/haitao.png"  v-if="dataList.isHaiTao==1" class='n_goods_shop_img' />
                <img src="../../images/juhuasuan.png"  v-if="dataList.isJuHuaSuan==1" class='n_goods_shop_img' />
                <img src="../../images/taoqianggou.png"  v-if="dataList.isTaoQiangGou==1" class='n_goods_shop_img' />
                <img src="../../images/video.png"  v-if="dataList.isVideo==1" class='n_goods_shop_img'/>{{dataList.title}}</p>
                <div class="des_wrapper">
                  <div class="des_content">
                    <p class="mark">不可错过 限今日</p>
                    <div class="goods_coupon">
                      <span class="goods_coupon_l">领券直降</span><img src="../../images/jrqg_coupon_bg.png" class="goods_coupon_c" /><span class="goods_coupon_r">￥{{dataList.money
          }}</span>
                    </div>
                    <div class="goods_money">
                      <span class="goods_money_l"><span class="s1">{{dataList.zk_final_price}}</span><span class="s2">￥{{dataList.reserve_price}}</span></span>
                    </div>
                    <div class="be_left">
                      <div class="be_left_innner">
                        即将抢完
                      </div>
                    </div>
                  </div>
                  <div class="time_wrapper">
                      <p class="time">

                      </p>
                      <div class="btn">
                        马上抢 >
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <!--未开枪-->
    <div class="not_buy_wrapper" v-if="showGrapModal">
      <div class="not_begin_banner z_banner">
        <div class="coupon_goods_list_ul">
          <router-link :to="{ name: 'item', params: { id: dataList.id }}" v-for="(dataList,index) in dataLists" :key="dataList.id" :class="index==0?'coupon_goods_list_li1':'coupon_goods_list_li'">
            <div v-if="index==0"  class="coupon_goods_list_li1_inner">
              <div class="li_left">
                <strong class="czg">超值购</strong>
                <img :src="dataList.goodsPic" class="goods_pic mt40"/>
                <p v-if="index==1" class="left_coupon">还剩{{dataList.couponReserve
    }} 张券</p>
              </div>
              <div class="li_right">
                <p class="goods_title"><img src="../../images/tmallSelected.png"  v-if="dataList.mallType=='天猫'" class='n_goods_shop_img'/>
                <img src="../../images/taobao.png"  v-if="dataList.mallType!='天猫'" class='n_goods_shop_img' />
                <img src="../../images/haitao.png"  v-if="dataList.isHaiTao==1" class='n_goods_shop_img' />
                <img src="../../images/juhuasuan.png"  v-if="dataList.isJuHuaSuan==1" class='n_goods_shop_img' />
                <img src="../../images/taoqianggou.png"  v-if="dataList.isTaoQiangGou==1" class='n_goods_shop_img' />
                <img src="../../images/video.png"  v-if="dataList.isVideo==1" class='n_goods_shop_img'/>{{dataList.goodsName}}</p>
                <div class="des_wrapper">
                  <div class="des_content">
                    <p class="mark">不可错过 限今日</p>
                    <div class="goods_coupon">
                      <span class="goods_coupon_l">领券直降</span><img src="../../images/jrqg_coupon_bg.png" class="goods_coupon_c" /><span class="goods_coupon_r">￥{{dataList.money
          }}</span>
                    </div>
                    <div class="goods_money">
                      <span class="goods_money_l"><span class="s1">￥{{dataList.zk_final_price}}</span><span class="s2">￥{{dataList.reserve_price}}</span></span>
                    </div>
                    <div class="be_left">
                      <div class="be_left_innner">
                      </div>
                      <p class="be_left_text">
                        即将开抢
                      </p>
                    </div>
                  </div>
                  <div class="time_wrapper">
                      <p class="time">

                      </p>
                      <div class="btn_z">
                        开团提醒
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else  class="coupon_goods_list_li1_inner center">
              <div class="li_left">
                <img :src="dataList.pic_url" class="goods_pic"/>
                <p v-if="index==1" class="left_coupon">还剩{{dataList.couponReserve
    }} 张券</p>
              </div>
              <div class="li_right">
                <p class="goods_title"><img src="../../images/tmallSelected.png"  v-if="dataList.mallType=='天猫'" class='n_goods_shop_img'/>
                <img src="../../images/taobao.png"  v-if="dataList.mallType!='天猫'" class='n_goods_shop_img' />
                <img src="../../images/haitao.png"  v-if="dataList.isHaiTao==1" class='n_goods_shop_img' />
                <img src="../../images/juhuasuan.png"  v-if="dataList.isJuHuaSuan==1" class='n_goods_shop_img' />
                <img src="../../images/taoqianggou.png"  v-if="dataList.isTaoQiangGou==1" class='n_goods_shop_img' />
                <img src="../../images/video.png"  v-if="dataList.isVideo==1" class='n_goods_shop_img'/>{{dataList.title}}</p>
                <div class="des_wrapper">
                  <div class="des_content">
                    <p class="mark">不可错过 限今日</p>
                    <div class="goods_coupon">
                      <span class="goods_coupon_l">领券直降</span><img src="../../images/jrqg_coupon_bg.png" class="goods_coupon_c" /><span class="goods_coupon_r">￥{{dataList.money
          }}</span>
                    </div>
                    <div class="goods_money">
                      <span class="goods_money_l"><span class="s1">￥{{dataList.zk_final_price}}</span><span class="s2">￥{{dataList.reserve_price}}</span></span>
                    </div>
                    <div class="be_left">
                      <div class="be_left_innner">

                      </div>
                      <p class="be_left_text">
                        即将开抢
                      </p>
                    </div>
                  </div>
                  <div class="time_wrapper">
                      <p class="time">

                      </p>
                      <div class="btn_z">
                        开团提醒
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script type = "text/ecamscript-6">
  import Vue from 'vue'
  import { Indicator } from 'mint-ui' //提示搜索优惠券
  import SwiperVue from 'swiper'
  import 'swiper/dist/css/swiper.min.css'
  import GrapBuyingNav from './grapBuyingNav'
  export default {
    name:"grapBuying",
    data(){
      return {
        url:'',
        dataLists:[],
        page:1,
        showGrapModal:false,
        loading:false,
        REQUIRE:false,
        pageSize:11,
        startTime:"",
        endTime:"",
        currentHours:"",
        currentDay:""
      }
    },
    methods:{
     /*axios调用数据*/
      login () {
        this.url = "api/getTaoQiangGou.php?page="+this.page+"&pageSize="+this.pageSize+"&startTime="+this.startTime+"&endTime="+this.endTime//用商品列表页url代替
        console.log(this.url )
        this.$ajax.autoService
            .login(this.url)
            .then((res) => {
              console.log(res)
              this.dataLists = this.dataLists.concat(res.data.results.results.map(function(item){
                // item.finalPrice = (item.price - item.money).toFixed(2);
                // item.coupon_price = parseInt(item.coupon_price)
                // item.goodsName = item.goodsName.slice(0,36)
                var temp = item.pic_url
                temp = temp.replace('https:', '')
                temp = temp.replace('http:', '')
                item.pic_url = "http:" + temp
                return item
              }))
              //this.loading = false
              this.$nextTick(() => {
                this.REQUIRE = true;
                this.loading = false;
                Indicator.close()
              });
              //console.log(this.dataLists)
            }, (res) => {
                console.log("error")
                this.REQUIRE = true;
            })
       },
       /*axios向下加载*/
       scrollBottom() {
        // 滚动到页面底部时，请求前一天的文章内容
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

          if (((window.screen.height + scrollTop) > (document.body.clientHeight)-10)&& this.REQUIRE) {
          // 请求的数据未加载完成时，滚动到底部不再请求前一天的数据
          this.REQUIRE = false;
          this.loading = true;
          this.tips = '努力加载中...';
          this.page+=1
          this.pageSize=10
          this.login(this.url)
          Indicator.open('正在加载优惠券');

    }
  },
  lisetenFromChildEvent (data,data1,data2){
    if(data1=="grap"){//点击的是即将开始
      this.showGrapModal = true
    }
    else {//点击的是已开始
      this.showGrapModal = false;
      if(data1=="grapping1"){

      }
    }
  }
},
  created (){
    var t = new Date()//获取当前年月日
    var date = t.getDate();
    var month= t.getMonth() +1;
    var year= t.getFullYear();
    if(month<10){
      month = "0"+month
    }
    this.currentDay = year+"-"+month+"-"+date
    this.currentHours = t.getHours();//获取当前小时
    this.startTime=this.currentDay+" "+this.currentHours+":00:00",
    this.endTime=this.currentDay+" "+(this.currentHours+2)+":00:00",
   this.login(this.url)
  },
  mounted(){
    var mySwiper = new SwiperVue('.swiper-container', {
      "autoplay": false,
      'direction': 'horizontal',
      "slidesPerView" : '5.5',
       'loop': false
    })
     window.addEventListener('scroll', this.scrollBottom)
  },
  components:{
    "grapBuyingNav":GrapBuyingNav
  },
  beforeDestroy(){
    Indicator.close()
  },
  }
</script>
<style lang="stylus">
  .t_page
    .begin_banner
      width:100%
      padding-top:240px
      background:url(../../images/xsfq_bg.jpg)no-repeat left top
      background-size:100% 546px
    .not_begin_banner
      width:100%
      padding-top:240px
      background:url(../../images/zdkq_bg.jpg)no-repeat left top
      background-size:100% 628px
    .z_banner
      .coupon_goods_list_li
        width:100%
        display:block
        padding:30px 15px 30px 35px
        background:#fff
        width:100%
        box-sizing:border-box
        border-top:1px solid #e6e6e6
        box-sizing:border-box
      .coupon_goods_list_li1
        width:715px
        padding:20px
        background:#fff
        border-radius:20px
        display:block
        box-sizing:border-box
        margin:0 auto 20px auto
      .coupon_goods_list_li,.coupon_goods_list_li1
        .coupon_goods_list_li1_inner
          display:flex
          &.center
            align-items:center
          .li_left
            flex:0 0 240px
            .czg
              font-size:30px
              color:#333
              font-weight:bold
            .goods_pic
              width:220px
              height:170px
              display:block
              &.mt40
                margin-top:40px
          .li_right
            flex:1
            .goods_title
              font-size:30px
              color:#333
              display: -webkit-box;
              -webkit-line-clamp:2;
              -webkit-box-orient: vertical
              overflow:hidden
              height:80px
              line-height:40px
              .n_goods_shop_img
                width:20px
                height:20px
                vertical-align:middle
            .des_wrapper
              color:#fff
              line-height:36px
              font-size:0px
              margin-top:25px
              display:flex
              .des_content
                flex:1
                .mark
                  font-size:24px
                  color:#999
                  margin-bottom:15px
                .goods_coupon_l
                  padding:0 8px
                  background:#ff6500
                  display:inline-block
                  vertical-align:top
                  font-size:22px
                  height:36px
                .goods_coupon_c
                  width:13px
                  height:36px
                  vertical-align:top
                .goods_coupon_r
                  background:#ff5400
                  display:inline-block
                  vertical-align:top
                  padding:0 10px
                  height:36px
                  font-size:22px
                .goods_money
                  margin-top:20px
                  .s1
                    font-size:36px
                    color:#f40
                  .s2
                    font-size:24px
                    color:#999
                    margin-left:10px
                    text-decoration:line-through
                .be_left
                  width:220px
                  height:24px
                  background:#ffe4c4
                  border-radius:12px
                  overflow:hidden
                  margin-top:5px
                  .be_left_innner
                    width:220px
                    height:24px
                    background:linear-gradient(to right,#f40,#f80)
                    font-size:20px
                    color:#fff
                    text-align:center
                    line-height:24px
                  .be_left_text
                    position:absolute
                    left:0px
                    top:0px
                    width:220px
                    height:24px
                    color:#fff
                    text-align:center
                    line-height:24px
              .time_wrapper
                flex:0 0 170px
                .time
                  position:relative;
                  width:88px
                  height:103px
                  margin:0 auto
                  .bubble
                    color:#ffcfad
                    width:88px
                    height:103px
                    position:absolute
                    left:0px
                    top:0px
                    z-index:1
                    background:url("../../images/burble.png")no-repeat left top
                    display:block
                    background-size:88px 103px
                .time_content
                  position:relative
                  z-index:3
                  padding-top:10px
                  display:block
                  text-align:center
                  .time1
                   font-size:18px
                   color:#ff4400
                   display:block
                   line-height:36px
                   .time1_big
                     font-size:36px
                  .time2
                    font-size:18px
                    color:#ff4400
                    display:block
                    line-height:18px
                .btn
                  width:100%
                  height:60px
                  background:#ff4400
                  font-size:28px
                  color:#fff
                  text-align:center
                  line-height:60px
                  margin-top:25px
                  border-radius:10px
                .btn_z
                  width:100%
                  height:60px
                  font-size:28px
                  color:#fff
                  text-align:center
                  line-height:60px
                  margin-top:25px
                  border-radius:10px
                  background:#af58ea

</style>



// WEBPACK FOOTER //
// src/components/goodsNav/grapBuying.vue